import { decode } from "../utils";

export const Decoder = {
  methods: {
    decodeContent(content) {
      return decode(content);
    }
  }
};
